// extracted by mini-css-extract-plugin
export var container = "RuleCard-module--container--2bKTd";
export var animation = "RuleCard-module--animation--VG4rw";
export var ruleIcon = "RuleCard-module--rule-icon--11xXK";
export var content = "RuleCard-module--content--32LFz";